import { render, staticRenderFns } from "./SendReset.vue?vue&type=template&id=4ac4e369&"
import script from "./SendReset.vue?vue&type=script&lang=js&"
export * from "./SendReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports